<template>
    
    <div v-if="showLoader" class="flex  justify-center mt-10">

        <ripple-loader ></ripple-loader>
    </div>
    
    <div v-else class="lg:mb-40 h-4/5 lg:h/5/6">

        <div class="flex flex-col lg:flex-col-reverse justify-center">

            <div class="mb-2 ms-2 mt-5">

                <my-swipe/>
            <!-- <swiper-test/> -->
            </div>
            
            <div class="lg:mt-10 sticky top-0 z-50 w-full flex justify-center">

                <div class="w-2/3 border border-blue-500 bg-white rounded-md">

                    <login :reloadAfterLogout="reloadAfterLogout"/>
                </div>
            </div>
        </div>

        <div v-if="businessView">

            <div class="flex justify-center w-full text-white" >
                <a class="bg-blue-900 rounded w-40" href="https://1drv.ms/b/s!ApNwgYOBaGURinSdiJJlXgHFFV6U?e=CpFZRT">{{$t('business.BusinessManual')}}   </a>
            </div>

        </div>

        <div class="lg:mt-64">

        </div>

        <!-- <div class="lg:mt-64 mb-64">

            <main-public-info-page/>

        </div> -->

        <div class="myFixedPaddingHeight">

        </div>

        <!-- <div class="mt-2 ms-2">

            <my-horizontal-list></my-horizontal-list>
        </div> -->

        <div v-bind:class="{'hidden': !contactDropdownPopoverShow, 'block': contactDropdownPopoverShow}" 
        class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mb-1" ref="popoverContactRef">
            
            <a v-if ="$countryCode == 'KW'" href="https://www.instagram.com/pnadi.app"  
            class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">

            <img src="@/assets/images/instagram-icon.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

            <!-- <span class="tab tab-explore block text-xs"><p>Instagram</p></span> -->
            </a>
            
            <a v-if ="$countryCode == 'KW'" :href="`https://wa.me/0096599003047`" 
            class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
            
                <img src="@/assets/images/whatsapp.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
            </a>

            <a  v-else :href="`https://wa.me/004407818378901`" 
            class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
            
                <img src="@/assets/images/whatsapp.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Whatsapp</p></span> -->
            </a>

            <a :href="`mailto: pnadi@pnadi.com`"  
            class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                <img src="@/assets/images/mail.png" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Email</p></span> -->
            </a>
            
            <div class="h-0 my-2 border border-solid border-t-0 border-gray-900 opacity-25"></div>

            <a v-if ="$countryCode == 'KW'" :href="`tel:0096599003047`" class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                <img src="@/assets/images/call-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Call</p></span> -->
            </a>

            <a v-else :href="`tel:004407818378901`" class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                
                <img src="@/assets/images/call-icon.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                <!-- <span class="tab tab-explore block text-xs"><p>Call</p></span> -->
            </a>
        </div>

        <div id="whatsAppIcon" ref="contactBtnDropdownRef" class="fixed flex z-10 right-0 bottom-0 opacity-100 w-10 h-12 mb-64 rounded-full me-2">
                        
            <div class="self-center opacity-100 text-MyFloatButtonsText text-xl">

                <a @click="toggleContactDropdown">
                    
                    <img class="object-scale-down w-8 h-8" src="@/assets/images/contact-icon.svg" alt="Contact">
                </a>
            </div>
        </div> 
    </div>
</template>

<script>

// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'

import login from '../components-v2/home/Login';

import componentHelpers from '../classes/componentHelpers';

import { RingLoader } from 'vue-spinners-css';

import { createPopper } from '@popperjs/core';

// import VueHorizontalList2 from "@/vue-horizontal-list.vue";

// import mySwipe from '../components-v2/controls/MySwipe'
// import mySwipe from '../components-v2/controls/MyServerSwipe'
import mySwipe from '../components-v2/controls/NewServerSwipe'

// import swiperTest from '../components-v2/controls/SwiperTest'
import componentsHelpers from '../classes/componentHelpers';

import mainPublicInfoPage from '../publicUsersComponents/mainPublicInfoPage.vue'

// import MyHorizontalList from '../components-v2/controls/MyHorizontalList.vue';

export default {

    created(){

    // console.log(`apollo: ${this.$apollo}`);
    //   console.log(`toasted: ${this.$toasted}`);
    //   console.log(`t: ${this.$t}`);

    // console.log(`mode: ${process.env.NODE_ENV}`);

    // console.log(`dev mode: ${process.env.NODE_ENV}`)
    // console.log(`dev == development: ${process.env.NODE_ENV == 'development'}`)

    const apollo = this.$apollo;

    const toasted = this.$toasted;

    const userId = this.userId;

    const t = this.$t;

    if(localStorage.hasOwnProperty("showedBanner")){
    
    }else{
      
      localStorage.setItem('showedBanner', 'true');

      setTimeout(function(){

        componentsHelpers.toastIt(toasted, this.$t('home.addAppToast') , 1, 'toasted-primary', true);

      },10000);
    }
  },

    async mounted(){

        // this.swiper.slideTo(3, 1000, false)

        this.$layoutType = 0;
        
        // console.log(`in viewv2 home`);
        
      if(localStorage.hasOwnProperty('businessView')){

        const businessView = localStorage.getItem('businessView');

        if(businessView == 'true'){
        
        this.businessView = true;

          const goTo = localStorage.setItem('businessLayout1', 'home');
        }else{

          const goTo = localStorage.setItem('clientLayout1', 'home');
        }
      }else{

        localStorage.setItem('businessView', 'false');
        
        localStorage.setItem('clientLayout1', 'home');

        this.$layoutType = 0;
      }

      const toast = this.$toasted;

    this.showLoader = true;

    if(this.$route.query.redirected === 'true')
        {

          this.$router.replace({'query': null});
        
          console.log(`Created, inside app.vue component and redirected`);
          
          await this.reloadWebsite();
        }

      this.showLoader = false;

  },

    components:{

        login,
        RingLoader,
        mySwipe,
        mainPublicInfoPage
        // Swiper,
        // SwiperSlide
        // VueHorizontalList,
        // swiperTest,
        // MyHorizontalList
    },

    //  directives: {
    // swiper: directive
    // },

    methods: {

        echo(item){

            // console.log(`title: ${item.index}`);
        },

          swiper() {
            
            return this.$refs.mySwiper.$swiper
        },

        // onSwiper(swiper) {
        //         console.log(swiper)
        //     },

        // onSlideChange() {
        //         console.log('slide change')
        // },

        toggleContactDropdown(){

            // console.log(`inside toggleContactDropdown`);
            
            const test = new createPopper();

            if(this.contactDropdownPopoverShow){

                    // console.log(`inside if`);

                this.contactDropdownPopoverShow = false;
            } else {
                                // console.log(`inside else`);

                this.contactDropdownPopoverShow = true;
                new createPopper(this.$refs.contactBtnDropdownRef, this.$refs.popoverContactRef, {
                placement: "top"
                });
            }
        },

        reLoadApp(){

            location.reload(true);
        },

        resetApp(){

            localStorage.clear();

            location.reload(true);
        },

        changeLanguage(){

        componentsHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);
    },


        async reloadWebsite(){

            await this.sleep(2000);

            while(localStorage.getItem('for_pnadi') === ''){
                    

                    await this.sleep(3000);
            }
            await this.sleep(1000);

            this.showLoader = false;
            location.reload();
        },

        async reloadAfterLogout(){

        this.showLoader = true;
        await this.sleep(2000);
        while(localStorage.getItem('for_pnadi') !== ''){
                
                await this.sleep(1000);
        }
        this.showLoader = false;
        location.reload();
        },

        async sleep(ms){
            
            this.count = this.count + 1;
            return await new Promise(resolve => setTimeout(resolve, ms));
        },
    },

    data:function (){

        return{
            
            businessView: false,
            // items: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => {
            //     return {

            //     index: i,
            //     title: `Responsive 4-3-2-1`,
            //     content: `Responsive Content ${i}!`,
            //     };
            // }),

             options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { size: 4 },
                ],

                list:{

                    padding: 0
                }
            },

            options2: {
                responsive: [
                { end: 20, size: 1 },
                { start: 20, end: 40, size: 2 },
                { start: 40, end: 60, size: 3 },
                { start: 60, end: 80, size: 4 },
                { start: 80, end: 100, size: 4 },          
                ],
            },

            myCube: [

                {
                    index: 0,
                    title: this.$t('ads.imgAd1'),
                    img: require('@/assets/images/swiper-dance.jpg')
                },
                {
                    index: 1,
                    title: this.$t('ads.imgAd2'),
                    img: require('@/assets/images/swiper-class.jpg')
                },
                {
                    index: 2,
                    title: this.$t('ads.imgAd3'),
                    img: require('@/assets/images/swiper-ma.jpg')
                },
                {
                    
                    index: 3,
                    title: this.$t('ads.imgAd4'),
                    img: require('@/assets/images/swiper-gym.jpg')
                },
                {
                    
                    index: 4,
                    title: this.$t('ads.imgAd5'),
                    img: require('@/assets/images/swiper-workout.jpg')
                },
            ],

            showLoader: false,
            isPinkStyle: true,
            contactDropdownPopoverShow: false,
            isDevelopmentMode: process.env.NODE_ENV == 'development',
            
            swiperOptions: {
                loop: true,

                // fadeEffect: { crossFade: true },
				// effect: "fade", 
                 effect: 'cube',

                //  effect: 'coverflow',
                //     coverflowEffect: {
                //         rotate: 50,
                //     },
                pagination: {
                    el: '.swiper-pagination'
                },
                // Some Swiper option/callback...

            banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],

            }
            // businessView: false,
        }
    },

    watch: {
        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;

            // console.log(`in Watcehr: pink is ${newValue}`);
            }
        }
};
</script>

<style scoped>
.item {
  padding: 16px 24px;
  border-radius: 3px;
  background: #f5f5f5;
}
</style>
